import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'

export const LoginFormRoot = styled('form', {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  backgroundColor: '$tertiary-200',
  minHeight: '100vh',
  padding: '$10 $3',

  '@bp2': {
    $$headerHeight: '80px',
    padding: '$10 144px',
    paddingTop: 'calc($$headerHeight + $10)',
  },

  '@bp3': {
    maxWidth: 'calc($max/2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  variants: {
    justifyContent: {
      start: {
        justifyContent: 'flex-start',
      },
      spaceBetween: {
        justifyContent: 'space-between',
      },
    },
  },
})

export const CreateAMealPlan = styled(Stack, {
  alignSelf: 'center',
  '&': {
    [`${Text}`]: {
      whiteSpace: 'nowrap',
    },
  },
})

export const TabContainer = styled(Stack, {
  borderBottom: '1px solid $tertiary-300',
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
})

export const Tab = styled('button', {
  background: 'none',
  border: 'none',
  padding: '$2 $1',
  cursor: 'pointer',
  position: 'relative',
  fontSize: '$body',

  color: '$accent-black',
  transition: 'color 0.2s ease',
  textAlign: 'center',
  width: '100%',

  '&:hover': {
    color: '$primary-500',
  },

  variants: {
    active: {
      true: {
        color: '$accent-black',
        fontWeight: '$bold',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-1px',
          left: 0,
          right: 0,
          height: '2px',
          backgroundColor: '$accent-red',
          width: '100%',
        },
      },
    },
  },
})
